import { useQuery } from "@tanstack/react-query";

import { getModulesModuleID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const getModuleDetailQueryKey = (moduleID: string) => [
  "MODULE_DETAIL_QUERY",
  moduleID,
];

export function useModuleDetailQuery(moduleID: string | undefined) {
  return useQuery({
    queryKey: getModuleDetailQueryKey(moduleID ?? ""),
    queryFn: processResponse(() => getModulesModuleID(moduleID ?? "")),
    enabled: !!moduleID,
  });
}
